/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  image: {
    id: "b2b.provozni-informace-form.field.image.label",
    defaultMessage: "Image"
  },
  titleCs: {
    id: "b2b.provozni-informace-form.field.title.label.cs",
    defaultMessage: "Title in Czech"
  },
  titleEn: {
    id: "b2b.provozni-informace-form.field.title.label.en",
    defaultMessage: "Title in English"
  },
  titleCsPlaceholder: {
    id: "b2b.provozni-informace-form.field.title.placeholder.cs",
    defaultMessage: "Enter the title of the information in Czech"
  },
  titleEnPlaceholder: {
    id: "b2b.provozni-informace-form.field.title.placeholder.en",
    defaultMessage: "Enter the title of the information in English"
  },
  descriptionCs: {
    id: "b2b.provozni-informace-form.field.description.label.cs",
    defaultMessage: "Description in Czech"
  },
  descriptionEn: {
    id: "b2b.provozni-informace-form.field.description.label.en",
    defaultMessage: "Description in English"
  },
  descriptionCsPlaceholder: {
    id: "b2b.provozni-informace-form.field.description.placeholder.cs",
    defaultMessage: "Enter the description of the information in Czech"
  },
  descriptionEnPlaceholder: {
    id: "b2b.provozni-informace-form.field.description.placeholder.en",
    defaultMessage: "Enter the description of the information in English"
  },
  contentCs: {
    id: "b2b.provozni-informace-form.field.content.label.cs",
    defaultMessage: "Content in Czech"
  },
  contentEn: {
    id: "b2b.provozni-informace-form.field.content.label.en",
    defaultMessage: "Content in English"
  },
  contentCsPlaceholder: {
    id: "b2b.provozni-informace-form.field.content.placeholder.cs",
    defaultMessage: "Enter the content of the information in Czech"
  },
  contentEnPlaceholder: {
    id: "b2b.provozni-informace-form.field.content.placeholder.en",
    defaultMessage: "Enter the content of the information in English"
  },
  attachments: {
    id: "b2b.provozni-informace-form.field.attachments.label",
    defaultMessage: "Attachments"
  },
  submit: {
    id: "b2b.provozni-informace-form.button.submit",
    defaultMessage: "Save"
  },
  delete: {
    id: "b2b.provozni-informace-form.button.delete",
    defaultMessage: "Delete"
  },
  cancel: {
    id: "b2b.provozni-informace-form.button.cancel",
    defaultMessage: "Cancel"
  },
  submitDialogTitle: {
    id: "b2b.provozni-informace-form.dialog.submit",
    defaultMessage: "Saving operational information"
  }
});

export default () => useMessages(MESSAGES);
